<template>
  <div>

    <div v-if="getCurrent.mount != 'live' && showLetterAndVideo" class="row justify-content-between">
      <div class="col-md-12">
        <h2 class="m-0 mb-0 mt-3"> {{ playing }}</h2>
      </div>
      <div class="col embed-responsive embed-responsive-16by9 video" v-if="getCurrent.song_data.video">
        <iframe :src="getVideo"
                sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation"></iframe>
      </div>
      <!--NAO TEM VIDEO-->
      <div class="col embed-responsive embed-responsive-16by9 video" v-if="!getCurrent.song_data.video">
        <div class="sem-video video">
          <i class="fab fa-youtube"></i>
          <hr>
          Nenhum vídeo para esta música
        </div>
      </div>

      <div class="col" v-if="getCurrent.song_data.lyric">
        <vue-scrollbar classes="my-scrollbar" ref="Scrollbar">
          <div class="scroll-me">
            <pre> {{ getCurrent.song_data.lyric }} </pre>
          </div>
        </vue-scrollbar>
      </div>
      <!--NAO TEM LETRA-->
      <div class="col sem-letra" v-if="!getCurrent.song_data.lyric">
        Letra não disponível
      </div>
    </div>
  </div>
</template>

<script>
  import services from '../service/api'
  import $ from 'jquery';
  import jplayer from 'jplayer';
  import rangesliderJs from 'rangeslider-js'
  import VueScrollbar from 'vue2-scrollbar';

  export default {
    name: "HeaderComp",
    props: [],
    components: {
      VueScrollbar
    },
    data() {
      return {
        showLetterAndVideo: window.config.site.letterVideo,
        site_title_name: window.config.site.site_title_name,
      }
    },
    mounted() {
    },
    methods: {},
    computed: {
      getCurrent() {
        return this.$store.getters['getCurrentInfo']
      },
      getBuilderInfo() {
        return this.$store.getters['getBuilderInfo']
      },
      getVideo() {
        if (this.getCurrent.song_data.video) {
          return "https://www.youtube.com/embed/" + this.getCurrent.song_data.video + "?rel=0&amp;controls=0&amp;showinfo=0&modestbranding=1&frameborder=0";
        }
      },
      playing() {
        //se tem letra e video
        if (this.getCurrent.song_data.video && this.getCurrent.song_data.lyric) {
          return 'Tocando agora (letra e vídeo)';
        }
        //se tem letra e nao tem video
        if (this.getCurrent.song_data.video && !this.getCurrent.song_data.lyric) {
          return 'Tocando agora ( vídeo)';
        }
        //se tem video e nao tem letra
        if (this.getCurrent.song_data.lyric && !this.getCurrent.song_data.video) {
          return 'Tocando agora (letra )';
        }
        //se nao tem nem letra nem video
        if (!this.getCurrent.song_data.lyric && !this.getCurrent.song_data.video) {
          return '';
        }
      }
    },
  }
</script>
<style scoped>

  .embed-responsive-16by9::before {
    padding-top: 0 !important;
  }

  .my-scrollbar {
    min-width: 300px;
    max-height: 300px;
  }

  /*The Content*/
  .scroll-me {
    min-width: 200px;

  }

  .scrollbar {
    border-radius: 10px;
    min-height: 50px;
    cursor: pointer;
    background: rgba(0, 0, 0, 1) !important;
  }

  .my-scrollbar[data-v-f28e9bfe] {
    background: none;
  }

  .vue-scrollbar__scrollbar-vertical {
    background: #0a6aa1;
  }
</style>


// WEBPACK FOOTER //
// src/components/HeaderComp.vue